export interface UpgradeStat {
	current: number;
	total: number;
}

export enum FlagVariant {
	GREEN = "green",
	PURPLE = "purple",
	BLUE = "blue",
}

export enum EventFlagVariant {
	PURPLE = "event-purple",
	ORANGE = "event-orange",
	BLUE = "event-blue",
}

export enum FilterItems {
	NEWEST = "ui.newest",
	CHEAPEST = "ui.cheapest",
	PREMIUM = "ui.premium",
	SPECIAL = "ui.special",
	ALL = "ui.all",
	BUILDINGS = "ui.buildings",
	OTHER = "ui.other",
	TERRAIN = "ui.terrain",
}

export enum QuickToolActions {
	CUT = "cut",
	REMOVE = "remove",
	DEFEAT = "DEFEAT",
	SAVE_MATERIAL = "save_material_action",
	HIRE = "hire_action",
	TRADE = "trade_action",
	CLEAR = "clear_action",
	DEMOLISH = "demolish",
	BUILD = "build",
	NONE = "none",
	PUT_IN_INVENTORY = "put_in_inventory",
}

export const quickToolActionsSalvage = new Set<QuickToolActions>([
	QuickToolActions.SAVE_MATERIAL,
	QuickToolActions.HIRE,
	QuickToolActions.TRADE,
	QuickToolActions.CLEAR,
]);
